import React from 'react';
import { Modal } from './Modal';
interface TermsModalProps {
  onClose: () => void;
}
export const TermsModal: React.FC<TermsModalProps> = ({
  onClose
}) => {
  return <Modal title="Términos y Condiciones" onClose={onClose} data-id="element-339">
      <div className="space-y-4 text-gray-700" data-id="element-340">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-341">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-342">
          Al realizar la compra del Recetario Fit para Airfryer, usted acepta
          los siguientes términos y condiciones. Estos términos constituyen un
          acuerdo legal entre usted y Recetario Fit para Airfryer.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-343">
          2. Propiedad Intelectual
        </h3>
        <p data-id="element-344">
          Todo el contenido proporcionado en el Recetario Fit para Airfryer,
          incluyendo textos, gráficos, logotipos, imágenes, recetas y cualquier
          otro material está protegido por leyes de propiedad intelectual. Este
          contenido no puede ser reproducido, distribuido, o utilizado con fines
          comerciales sin autorización previa por escrito.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-345">
          3. Política de Reembolso
        </h3>
        <p data-id="element-346">
          Ofrecemos una garantía de satisfacción de 7 días. Si no estás
          satisfecho con tu compra, puedes solicitar un reembolso completo
          dentro de los 7 días posteriores a la fecha de compra. Para solicitar
          un reembolso, debes contactarnos a través de los canales oficiales
          proporcionados.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-347">
          4. Descargo de Responsabilidad
        </h3>
        <p data-id="element-348">
          La información proporcionada en el Recetario Fit para Airfryer es solo
          para fines educativos y no constituye asesoramiento médico o
          nutricional profesional. Consulte con un profesional de la salud antes
          de comenzar cualquier programa de dieta o ejercicio.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-349">
          5. Modificaciones
        </h3>
        <p data-id="element-350">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-351">
          6. Ley Aplicable
        </h3>
        <p data-id="element-352">
          Estos términos y condiciones se regirán e interpretarán de acuerdo con
          las leyes de Argentina, sin tener en cuenta sus disposiciones sobre
          conflictos de leyes.
        </p>
      </div>
    </Modal>;
};